export default "<div class=\"full-screen-container\">\n  <router-outlet></router-outlet>\n</div>\n"